function FooterLegal() {
  return (
    <footer style={estilos.footer}>
      <style>{`
  @media (max-width: 768px) {
    .footer-contenido {
      flex-direction: column !important;
      text-align: center !important;
      align-items: center !important;
      justify-content: center !important;
    }
    .footer-logo-copy {
      justify-content: center !important;
      text-align: center !important;
    }
    .footer-links {
      justify-content: center !important;
    }
  }
`}</style>
      <div style={estilos.contenido} className="footer-contenido">
        <div style={estilos.logoYCopy} className="footer-logo-copy">
          <a href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src="/logo-circulo.png" alt="Etern-Me" style={estilos.logo} />
          </a>
          <p style={estilos.copy}>
            2026 ETERN-ME · Todos los derechos reservados · Creado por Melina Rivera
          </p>
        </div>
        <div style={estilos.redes}>
          <a href="https://www.linkedin.com/company/etern-me/" target="_blank" rel="noopener noreferrer" style={estilos.redLink}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect width="4" height="12" x="2" y="9"/><circle cx="4" cy="4" r="2"/></svg>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61572155231213" target="_blank" rel="noopener noreferrer" style={estilos.redLink}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
          </a>
        </div>
        <div style={estilos.links} className="footer-links">
          <a href="/blog" style={estilos.link}>Blog</a>
          <a href="/privacidad" style={estilos.link}>Privacidad</a>
          <a href="/terminos" style={estilos.link}>Términos</a>
          <a href="/aviso-legal" style={estilos.link}>Aviso Legal</a>
        </div>
      </div>
    </footer>
  )
}
const estilos = {
  footer: { backgroundColor: '#2C1810', padding: '20px 32px', borderTop: '1px solid #3D2418', width: '100%' },
  contenido: { maxWidth: '1100px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' },
  logoYCopy: { display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' },
  logo: { width: '36px', height: '36px', objectFit: 'cover', borderRadius: '50%', flexShrink: 0 },
  copy: { color: '#ac9370', fontSize: '13px', margin: 0 },
  links: { display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' },
  link: { color: '#C4A882', fontSize: '13px', textDecoration: 'none' },
  redes: { display: 'flex', gap: '16px', alignItems: 'center' },
  redLink: { color: '#C4A882', display: 'flex', alignItems: 'center' },
}
export default FooterLegal
